<!-- <h2>Page not found</h2> -->
<!-- <div class="ship-image ship-image-wrapper">
    <img style="width:1000;height: 500px;" src="../../../assets/images/HTTP-404-Not-found-Error.jpg" />
</div> -->

<div id="main">
  <div class="fof">
    <h1>Error 404</h1>
    <h3>Oops page not found..</h3>
    <br>
    <a routerLink="/">
      Click me instead
    </a>
  </div>



</div>
